/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Storytelling (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'./RevealProperties',
	'baglass/core-client/js/core-client/utils/BrowserUtils',
	'underscore'
], function(revealProperties, BrowserUtils, _) {
	class LiveWidgetPropertiesFilter {
		constructor(widgetApi, dashboardApi) {
			this.widgetApi = widgetApi;
			this.dashboardApi = dashboardApi;

			this.api = {
				filter: this.filter.bind(this)
			};
		}

		getAPI(){
			return this.api;
		}

		filter(properties){
			return this.dashboardApi.getDashboardSvc('.StoryPaneService').then(storyPaneService => {
				if(properties && this.shouldFilter(storyPaneService)) {
					properties = properties.map(property => {
						if( revealProperties.properties[property.id] ){
							const overrides = revealProperties.properties[property.id];
							property = _.extend({}, property, overrides);
						}
						return property;
					});
				}
				return properties;
			});
		}
		shouldFilter(storyPaneService) {
			return !BrowserUtils.isIE11() && !storyPaneService.widgetAtStartOfCurrentScene(this.widgetApi.getId());
		}
	}
	return LiveWidgetPropertiesFilter;
});
